import { render, staticRenderFns } from "./BxProgressCircular.vue?vue&type=template&id=be57f1b6&"
import script from "./BxProgressCircular.vue?vue&type=script&lang=js&"
export * from "./BxProgressCircular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports